module.exports = __webpack_public_path__ + "static/media/malta.2efb0599.jpg";